import React, { useState } from 'react';
import {
    Button, CardBody, Card, Row, Col,
    Form,
    FormGroup, Label,
    Input,
    Container
} from 'reactstrap';
import { Link } from 'react-router-dom';



const HolidaysSettings = () => {


    return (
        <div className='AttendanceRules'>
            <Container>
                <Row>
                    <Col xs="12" md="12" sm="12">
                        <Card>

                            <CardBody className="">


                                <Link style={{ color: '#121127', marginBottom: '10px!important' }} to="/payroll-new/settings" className='text-nowrap'>
                                    <i className="fa fa-arrow-circle-left" style={{ color: '#72B566', fontSize: '16px' }} aria-hidden="true"></i> Back to settings management</Link>


                                <Form className="form" style={{ marginTop: '60px' }}>


                                    <Row>

                                        <Col className='col-md pr-0'>

                                            <FormGroup>
                                                <Label htmlFor="Halfdayholiday" className='text-nowrap'>Allow half day holiday</Label>
                                                <Input
                                                    type="text"
                                                    name="Halfdayholiday"
                                                    id="Halfdayholiday"
                                                    placeholder="type here"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className='col-md'>

                                            <FormGroup>
                                                <Label htmlFor="MaximumannualHolidays" className='text-nowrap'>Maximum annual holidays carryover</Label>
                                                <Input
                                                    type="text"
                                                    name="MaximumannualHolidays"
                                                    id="MaximumannualHolidays"
                                                    placeholder="type here"
                                                />
                                            </FormGroup>

                                        </Col>
                                    </Row>
                                    <Button
                                        color="success"
                                        className="bt float-right " type="submit"
                                    >Add
                                    </Button>
                                </Form>







                            </CardBody>
                        </Card>
                    </Col>

                </Row>



            </Container>

        </div>
    );
}

export default HolidaysSettings;
